import { render, staticRenderFns } from "./OrderItemEdit.vue?vue&type=template&id=30f5b73b&scoped=true&"
import script from "./OrderItemEdit.vue?vue&type=script&lang=js&"
export * from "./OrderItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemEdit.vue?vue&type=style&index=0&id=30f5b73b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f5b73b",
  null
  
)

export default component.exports